
<template>

	<div class="panel-body">

		<div class="col-xs-12">
            <div class="form-group">
                <label>Term</label>
                <select
                	@change="getMeetings"
                	class="form-control"
                	v-model="selectedTerm">
                	<option v-for="term in terms" :value="term.id">
                		{{term.name}}
                	</option>
            	</select>
            </div>
            <div v-if="groups">
            	<div v-for="(meetings, groupId) in groups">
            		<h4 class="cursor-pointer" @click="selectedGroup === groupId ? selectedGroup = null : selectedGroup = groupId">
            			{{determineGroupLabel(meetings[0])}}
						<i class="fa fa-caret-down" v-if="selectedGroup===groupId"></i>
                    	<i v-else class="fa fa-caret-right"></i>
            		</h4>

            		<div v-if="selectedGroup === groupId">

            			<table class="table table-striped table-bordered">
            				<thead>
            					<tr>
            						<th>Week</th>
            						<th>Start Time</th>
            						<th>Participants</th>
            						<td>Duration</td>
            						<th>Recording</th>
            					</tr>
            				</thead>
            				<tbody>
            					<tr v-for="meeting in meetings">
            						<td>{{getWeek(meeting.startTime)}}</td>
            						<td>{{meeting.startTime | shortDate}}</td>
            						<td>
            							<span v-if="meeting.zoom_report && meeting.zoom_report.participants">{{unique(meeting.zoom_report.participants).map(p => p.name).join(', ')}}</span>
            							<span v-else-if="meeting.zoom_report">0</span>
            							<span v-else>No Report</span>
            						</td>
            						<td>
            							<span v-if="meeting.actualDuration">{{meeting.actualDuration}}</span>
            							<span v-else-if="meeting.zoom_report && meeting.zoom_report.participants && meeting.zoom_report.participants.length > 0">
            								{{getDuration(meeting.hostId, meeting.zoom_report.participants)}}
            							</span>
            							<span v-else>Unknown</span>
            							min
            						</td>
            						<td>
                                        <div></div>
            							<a v-if="meeting.archiveUrl" :href="meeting.archiveUrl" target="_blank">Link
                                            <span v-if="meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0">
                                                (
                                                <a :href="meeting.archiveUrl" target="_blank" class="recording">1</a>
                                                <span v-for="(recording, index) in meeting.secondaryRecordings">,
                                                    <a :href="recording" target="_blank" class="recording"> {{ index + 2 }} </a>
                                                </span>)
                                            </span>
                                        </a>
            							<span v-else>No recording</span>
            						</td>
            					</tr>
            				</tbody>
            				<tfoot></tfoot>
            			</table>
            			<!-- <pre>{{meetings}}</pre> -->
            		</div>

            	</div>
            </div>
		</div>

	</div>

</template>

<script>

import terms from './../../services/terms';
import meetings from './../../services/meetings';
import users from './../../services/users';

import _ from 'lodash';
import moment from 'moment';

export default {
    data() {
        return {
        	terms: null,
        	selectedTerm: null,
        	groups: null,
        	selectedGroup: null,
            supervisors: null,
        	now: new Date()
        }
    },
    components: {

    },
    async created() {
  		const now = new Date();
        await this.getSupervisors();
        terms.get(this).then((response) => {
            this.terms = response.data.terms.filter(t => new Date(t.startDate) < now && !t.name.toLowerCase().includes('challenge'))
            this.selectedTerm = this.terms[0].id;
            this.getMeetings();
        });
    },
    mounted() {

    },
    methods: {
        getSupervisors() {
            return users.getAll(this, 'Supervisor').then((response) => {
                this.supervisors = response.data.filter(s => s.group);
                return true;
            });

        },
        determineGroupLabel(meeting) {
            const group = meeting.student_group;
            const groupLabel = group.label.toLowerCase();

            if (groupLabel.includes('morning') || groupLabel.includes('afternoon') || groupLabel.includes('evening')) {
                // these groups were not named according to the group naming convention;
                // we need to get the name of the supervisor for the group and include the name in the label.

                const supervisor = this.supervisors.find(s => s.group.includes(meeting.group));
                if (supervisor) {
                    return supervisor.firstName + ' ' + supervisor.lastName + ' - ' + group.label;
                } else {
                    return group.label;
                }
            } else {
                return group.label;
            }

        },
    	getWeek(startTime) {
    		return moment(startTime).diff(this.termStart, 'weeks') + 1;
    	},
    	getDuration(hostId, participants) {

    		const supervisor = participants.find(p => p.id === hostId);

    		if (supervisor && supervisor.duration) {
    			return Math.round(supervisor.duration / 60);
    		}
    	},
    	unique(participants) {
    		const u = _.uniqBy(participants, (p)=>{
    			return p.id
    		});
    		return u;
    	},
    	getMeetings() {
    		meetings.getForTerm(this.selectedTerm).then((response)=>{
    			const grouped = _.groupBy(response.data.meetings, (m)=>{
    				return m.group
    			});

    			for (const key in grouped) {
					if (grouped.hasOwnProperty(key)) {
						const element = grouped[key];
						element.sort((a,b)=>{
							return new Date(a.startTime) - new Date(b.startTime);
						})
					}
				}
    			this.groups = grouped
    		})
    	}
    },
    computed: {
    	termStart() {
    		return this.terms.find(t => t.id === this.selectedTerm).startDate
    	}
    }
}
</script>

<style lang="scss" scoped>

table {
	table-layout: fixed;
}

</style>



// WEBPACK FOOTER //
// DirectorMeetings.vue?433dc5bf